module.exports = __webpack_public_path__ + "static/media/crunchbase-logo.d6c34394.png";